/* src/app/views/area-publica/home-page/mapa-brasil/qtd-projetos-regioes-br/qtd-projetos-regioes-br.component.scss */
.header-label-qtd-projs {
  font: normal normal nomral 14px/20px "Alegreya Sans Medium", sans-serif;
  letter-spacing: 0px;
  color: #757575;
  text-transform: uppercase;
}
.text-start {
  text-align: left;
}
.text-end {
  text-align: right;
}
.text-center {
  text-align: center;
}
#label-brasil,
#qtd-total-projs-brasil,
#qtd-total-municipios-projetos {
  font: normal normal 600 32px/39px "Montserrat", sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
}
.label-regiao,
.total-proj-regiao {
  font: normal normal normal 24px/34px "Alegreya Sans Medium";
  letter-spacing: 0px;
}
.label-estado,
.total-proj-estado {
  font: normal normal normal 14px/18px "Montserrat";
  font-weight: 500;
  letter-spacing: 0px;
  color: #2E3241;
}
.total-proj-regiao-percent {
  text-align: right;
  font: normal normal normal 28px/40px "Alegreya Sans Bold";
  letter-spacing: 0px;
  display: block;
}
.tema-norte {
  color: #1D9E5D;
}
.tema-nordeste {
  color: #D44C6C;
}
.tema-centro-oeste {
  color: #D65906;
}
.tema-sudeste {
  color: #4C90B7;
}
.tema-sul {
  color: #CC2336;
}
.regiao-item {
  border-top: 1px solid #F2F2F2;
  padding-top: 24px;
  width: 500px;
}
.subtexto-percent {
  text-align: right;
  font: normal normal normal 14px/20px "Alegreya Sans Medium";
  letter-spacing: 0px;
  color: #757575;
  text-transform: uppercase;
  white-space: nowrap;
}
.container-porcentagem-nacional {
  display: flex;
  align-items: flex-start;
}
.container-pine {
  padding: 0 40px 0 40px;
}
.container-percent {
  text-align: right;
}
@media screen and (max-width: 1400px) {
  .container-porcentagem-nacional {
    flex-direction: column;
  }
  .container-percent {
    padding: 0 40px 0 40px;
  }
  .regiao-item {
    width: 480px;
  }
  .container-porcentagem-nacional {
    max-width: 200px !important;
  }
}
/*# sourceMappingURL=qtd-projetos-regioes-br.component.css.map */
